<template>
  <div class="container">
    <content-header :data="[{text: '抽奖活动一览', path: '/lottery/list'},{text: lotteryName+' 奖品管理', path: ''}]"></content-header>
    <div class="content">
      <div class="content-bar">
        <el-button type="primary" icon="plus" @click="initNewHandle">添加</el-button>
      </div>
      <div class="content-list">
        <el-table
          :data="tableData"
          border
          stripe>
          <el-table-column
            prop="id"
            label="ID">
          </el-table-column>
          <el-table-column
            prop="name"
            label="奖品名称">
          </el-table-column>
          <el-table-column
            label="图片">
            <template slot-scope="scope">
            <img style="width:102px;height:36px":src="scope.row.image" v-if="scope.row.image"/>
            </template>
          </el-table-column>
          <el-table-column
            prop="number"
            label="件数">
          </el-table-column>
          <el-table-column
            label="等级">
            <template slot-scope="scope">
            <span>{{gradeOpts[scope.row.grade].name}}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="中奖率">
            <template slot-scope="scope">
            <span>{{scope.row.probability + '%'}}</span>
            </template>
          </el-table-column>

          <el-table-column
            label="操作"
            width="120">
            <template slot-scope="scope">
              <el-button @click="initEditHandle(scope)" type="text" size="small">修改</el-button>
              <el-button @click="deleteHandle(scope)" type="text" size="small">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="new-wrap">
        <el-dialog :title="curObj.id ? '修改奖品' : '添加奖品'" width="50%" :visible.sync="isObjShow">
          <el-form :model="curObj" :rules="curObjRules" ref="curObjForm">
            <el-form-item prop="prizeId" label="选择奖品" :label-width="formLabelWidth">
              <el-select v-model="curObj.prizeId" value-key="id" filterable placeholder="请选择"
              >
                <el-option
                  v-for="item in prizeOpts"
                  :key="item.prizeId"
                  :label="item.prizeName"
                  :value="item.prizeId">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="grade" label="等级" :label-width="formLabelWidth">
              <el-select v-model="curObj.grade" value-key="id" placeholder="请选择">
                <el-option
                  v-for="item in gradeOpts"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="number" label="数量" :label-width="formLabelWidth">
              <el-input v-model.number="curObj.number" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item prop="probability" label="中奖概率" :label-width="formLabelWidth">
              <el-input v-model="curObj.probability" auto-complete="off"></el-input>%
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="isObjShow = false">取 消</el-button>
            <el-button type="primary" @click="confirmHandle">确 定</el-button>

          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script type="text/babel">
  import LotteryModel from 'models/lottery'

  export default {
    data () {
      var validateDigit = (rule, value, callback) => {
        if (/^[0-9]+.?[0-9]*$/.test(value)) {
          callback()
        } else {
          callback(new Error('请输入小数'))
        }
      }
      return {
        tableData: [],
        gradeOpts: [{id: 0, name: '特等奖'}, {id: 1, name: '1等奖'}, {id: 2, name: '2等奖'}, {id: 3, name: '3等奖'}, {id: 4, name: '4等奖'}, {id: 5, name: '5等奖'}],
        lotteryId: '',
        lotteryName: '',
        curObj: {
          id: '',
          lotteryId: '',
          prizeId: '',
          grade: 1,
          number: 1,
          probability: 0.5
        },
        curObjRules: {
          prizeId: [{ required: true, message: '请选择奖品', trigger: 'blur' }],
          grade: [{ required: true, message: '请选择获奖等级', trigger: 'blur' }],
          number: [
            { required: true, message: '请输入数量', trigger: 'blur' },
            { type: 'number', message: '数量必须为数值' }
          ],
          probability: [
            { required: true, message: '请输入中奖概率', trigger: 'blur' },
            { validator: validateDigit, trigger: 'blur' }
          ]
        },
        isObjShow: false,
        formLabelWidth: '80px',
        //
        prizeOpts: [],
      }
    },
    created () {
      this.lotteryId = this.$route.query.id
      this.lotteryName = this.$route.query.name
      this.getObjList()
      //
      LotteryModel.findPrize({curPage: 1, pageSize: 1000, keywords: ''}).then(res => {
        let result = []
        for (let i = 0; i < res.rows.length; i++) {
          if (res.rows[i].status === 1) {
            result.push(res.rows[i])
          }
        }
        this.prizeOpts = result
      })
    },
    computed: {
    },
    methods: {
      getObjList () {
        LotteryModel.findPrizeXref({lotteryId: this.lotteryId}).then(res => {
          this.tableData = res
        })
      },
      //
      deleteHandle (item) {
        this.$confirm('是否确认删除？')
          .then(_ => {
            LotteryModel.deletePrizeXref({
              id: item.row.id,
            }).then(() => {
              this.tableData.splice(item.$index, 1)
              this.$message({ message: '删除成功', type: 'success' })
            }).catch(err => {
              this.$message({ message: err.message, type: 'error' })
            })
          })
          .catch(_ => {})
      },
      confirmHandle () {
        this.$refs.curObjForm.validate(valid => {
          if (!valid) return
          if (this.curObj.id) return this.editHandle()
          this.newHandle()
        })
      },
      initNewHandle () {
        this.curObj = {
          id: '',
          prizeId: '',
          lotteryId: '',
          grade: 1,
          number: 1,
          probability: 1
        }
        this.isObjShow = true
      },
      newHandle () {
        LotteryModel.createPrizeXref({
          prizeId: this.curObj.prizeId,
          lotteryId: this.lotteryId,
          grade: this.curObj.grade,
          number: this.curObj.number,
          probability: this.curObj.probability
        }).then(() => {
          this.getObjList()
          this.isObjShow = false
          this.$message({ message: '添加成功', type: 'success' })
        }).catch(err => {
          this.$message({ message: err.message, type: 'error' })
        })
      },
      initEditHandle (item) {
        this.curObj = {
          id: item.row.id,
          prizeId: item.row.prizeId,
          lotteryId: this.lotteryId,
          grade: item.row.grade,
          number: item.row.number,
          probability: item.row.probability
        }
        this.isObjShow = true
      },
      editHandle () {
        LotteryModel.updatePrizeXref({
          id: this.curObj.id,
          prizeId: this.curObj.prizeId,
          lotteryId: this.lotteryId,
          grade: this.curObj.grade,
          number: this.curObj.number,
          probability: this.curObj.probability
        }).then(() => {
          this.getObjList()
          this.isObjShow = false
          this.$message({ message: '更新成功', type: 'success' })
        }).catch(err => {
          this.$message({ message: err.message, type: 'error' })
        })
      }
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.container
  min-height: 100%
  background-color: #fff
  .content
    .content-bar
      padding: 20px
    .content-list
      padding-left: 20px
      padding-right: 20px
      padding-bottom: 40px
    .new-wrap
      .el-input
        width: 85%
      .avatar-uploader
          border: 1px dashed #d9d9d9
          border-radius: 6px
          cursor: pointer
          position: relative
          overflow: hidden
          width: 180px
          &:hover
            border-color: #409EFF
          .avatar-uploader-icon
            font-size: 28px
            color: #8c939d
            width: 180px
            height: 90px
            line-height: 90px
            text-align: center
          .avatar
            width: 180px
            height: 90px
            display: block
</style>



// WEBPACK FOOTER //
// src/views/LotteryPrizeManage.vue